import { IHttpService } from "../HttpService";
import ReportingPeriod, {
  IReportingPeriod
} from "../../model/reporting/ReportingPeriod";

export interface IPortalReportingPeriodService {
  getReportingPeriod(
    reportingPeriodId: number,
    languageCode: number
  ): Promise<IReportingPeriod>;
}

const PortalReportingPeriodService = (
  httpService
): IPortalReportingPeriodService => {
  const _http: IHttpService = httpService;
  const _basePath: string = "/api";
  const _reportingPeriodsPath: string = "/reporting-periods";

  return {
    async getReportingPeriod(reportingPeriodId: number, languageCode: number) {
      const path = _http.buildPath(
        _basePath,
        _reportingPeriodsPath,
        reportingPeriodId.toString()
      );
      const response = await _http.get(path, {
        params: {
          languageCode
        }
      });
      const responseJSON = await _http.toJSON(response);
      return ReportingPeriod(responseJSON);
    }
  };
};

export default PortalReportingPeriodService;
